export default function StaffBusTrackingPrivacyPolicy() {
  return (
    <div style={{ padding: "20px", maxWidth: "900px", margin: "auto", textAlign: "left" }}>
      <h1>Privacy Policy for SwitchGO</h1>
      <p>
        <strong>Last Updated:</strong> 01 June 2026
      </p>
 
      <p>
        SwitchGO we, respects your privacy. This Privacy Policy explains how we collect,
        use, and protect your information when you use our mobile application ("App") available on
        the Google Play Store.
      </p>
 
      <h2>1. Information We Collect</h2>
 
      <h3>1.1 Location Information</h3>
      <p>
        Our app collects <strong>real-time location data</strong> to enable staff bus tracking features.
      </p>
      <ul>
        <li>To show live bus location on map</li>
        <li>To track routes and stops</li>
        <li>To provide accurate arrival times</li>
      </ul>
 
      <h2>2. How We Use Your Information</h2>
      <ul>
        <li>To provide real-time bus tracking services</li>
        <li>To improve app functionality and performance</li>
        <li>To ensure safety and efficient operations</li>
      </ul>
 
      <h2>3. Permissions Used</h2>
 
      <h3>Location Permission</h3>
      <p>
        Used to track the live location of buses and users for accurate mapping and tracking features.
      </p>
 
      <h3>Internet Access</h3>
      <p>
        Required for fetching map data, location updates, and server communication.
      </p>
 
      <h2>4. Google Maps</h2>
      <p>
        Our app uses <strong>Google Maps services</strong> to display maps and location data.
      </p>
      <p>
        Google may collect and process data according to its Privacy Policy:
        <br />
        https://policies.google.com/privacy
      </p>
 
      <h2>5. Data Sharing</h2>
      <p>
        We do not sell or share your personal data with third parties except:
      </p>
      <ul>
        <li>When required by law</li>
        <li>To provide essential services like Google Maps</li>
      </ul>
 
      <h2>6. Data Security</h2>
      <p>
        We take reasonable measures to protect your data, including secure communication.
        However, no system can guarantee complete security.
      </p>
 
      <h2>7. User Control</h2>
      <p>You can:</p>
      <ul>
        <li>Enable or disable location permission anytime in settings</li>
        <li>Stop using the app if you do not agree with this policy</li>
      </ul>
 
      <h2>8. Children’s Privacy</h2>
      <p>
        This app is not intended for children under 13. We do not knowingly collect data from children.
      </p>
 
      <h2>9. Changes to This Privacy Policy</h2>
      <p>
        We may update this Privacy Policy periodically. Changes will be posted with an updated date.
      </p>
 
      <h2>10. Contact Us</h2>
      <p>
        <strong>Email:</strong> itconnect@switchmobilityev.com
        <br />
        <strong>Company Name:</strong> Switch Mobility Ltd
      </p>
    </div>
  );
}